/**
 * TokenStore - access_token / 用户信息 持久化（localStorage）
 *
 * 设计要点：
 * - access_token 跨 tab、跨刷新保留（F5 后从 storage 回退读取）
 * - 不存 refresh_token，不管理过期时间（后端自动续期）
 * - 不读取/不修改 URL（URL 注入由 AuthService 负责）
 */

export const KEY_TOKEN = 'newweb.access_token';
const KEY_USER = 'newweb.user_info';

class TokenStore {
  getToken(): string | null {
    try {
      const v = localStorage.getItem(KEY_TOKEN);
      return v && v.length > 0 ? v : null;
    } catch {
      return null;
    }
  }

  setToken(token: string): void {
    try {
      localStorage.setItem(KEY_TOKEN, token);
    } catch {
      /* 隐私模式 / 配额满：放弃持久化但不阻断流程 */
    }
  }

  getUser<T = Record<string, unknown>>(): T | null {
    try {
      const v = localStorage.getItem(KEY_USER);
      return v ? (JSON.parse(v) as T) : null;
    } catch {
      return null;
    }
  }

  setUser(user: unknown): void {
    try {
      localStorage.setItem(KEY_USER, JSON.stringify(user));
    } catch { /* ignore */ }
  }

  clearAuth(): void {
    try {
      localStorage.removeItem(KEY_TOKEN);
      localStorage.removeItem(KEY_USER);
    } catch { /* ignore */ }
  }

  /** 仅检查"是否有 token"，不判断有效性（有效性由 profile 心跳 / 业务 401 兜底验证） */
  isLoggedIn(): boolean {
    return this.getToken() !== null;
  }
}

export const tokenStore = new TokenStore();
export default tokenStore;
